import React from "react";
import Box from "@mui/material/Box";

const OpenIcon = () => {
  return (
    <Box
      sx={{
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        bgcolor: "#a9aebf",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "8px",
          height: "2px",
          bgcolor: "#1f1f1f",
          top: "20px",
          left: "13px",
          transform: "rotate(45deg)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          width: "8px",
          height: "2px",
          bgcolor: "#1f1f1f",
          top: "20px",
          left: "18px",
          transform: "rotate(-45deg)",
        }}
      />
    </Box>
  );
};

const CloseIcon = () => {
  return (
    <Box
      sx={{
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        bgcolor: "#e9ebef",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "8px",
          height: "2px",
          bgcolor: "#1f1f1f",
          top: "20px",
          left: "13px",
          transform: "rotate(45deg)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          width: "8px",
          height: "2px",
          bgcolor: "#1f1f1f",
          top: "20px",
          left: "18px",
          transform: "rotate(-45deg)",
        }}
      />
    </Box>
  );
};

export { OpenIcon, CloseIcon };